import React, { useMemo } from 'react';
import { useGetChecklistsInfinite } from '@area-restrita/api-client/endpoints/hang-tag/hang-tag.gen';

import { cn } from '@/lib/utils';
import Combobox, { ComboboxOption } from '@/components/Combobox';

interface IProps {
  value?: ComboboxOption | null;
  onChange?: (option?: ComboboxOption) => void;
  className?: string;
}

const ChecklistSelector: React.FC<IProps> = ({
  value,
  onChange,
  className,
}) => {
  const query = useGetChecklistsInfinite(
    { limit: 100, page: 1 },
    {
      query: {
        getNextPageParam: (lastPage, _, lastPageParam) =>
          lastPage.data.length > 0 ? lastPageParam + 1 : null,
      },
    },
  );

  const checklists = useMemo(
    () =>
      query.data?.pages.flatMap<ComboboxOption>((page) =>
        page.data.map((checklist) => ({
          label: checklist.name,
          value: checklist.id,
        })),
      ) ?? [],
    [query.data],
  );

  return (
    <Combobox
      options={checklists}
      onChangeValue={onChange}
      value={value}
      placeholder="Select checklist..."
      searchPlaceholder="Search checklist..."
      isLoading={query.isFetching}
      className={cn('w-full', className)}
    />
  );
};

export default ChecklistSelector;
